import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function HeroSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const scrollToBuy = () => {
    const element = document.getElementById('offer');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section ref={ref} className={`relative w-full bg-navy pt-10 pb-10 px-6 md:pt-16 md:pb-16 overflow-hidden fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-37">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-38">
        <h1 className="font-serif text-4xl md:text-6xl text-gold mb-3 leading-tight" data-id="element-39">
          Silencia a la <br className="md:hidden" data-id="element-40" />
          "Mamá Juez"
        </h1>

        <p className="font-sans text-lg md:text-xl text-cream/90 mb-8 max-w-xl leading-relaxed" data-id="element-41">
          Una guía práctica de 14 días para observar y trabajar con el diálogo
          interno, sin exigencias ni fórmulas mágicas.
        </p>

        {/* Opening Lead */}
        <div className="text-left w-full max-w-2xl mb-8" data-id="element-42">
          <div className="font-serif italic text-lg md:text-2xl text-cream/90 space-y-4 leading-relaxed border-l-2 border-gold/30 pl-6" data-id="element-43">
            <p data-id="element-44">Hay un tipo de cansancio que no se alivia solo con descanso.</p>
            <p data-id="element-45">Es el cansancio de sentirte evaluada.</p>
            <p data-id="element-46">
              Trabajas y sientes que estás abandonando.
              <br data-id="element-47" />
              Te quedas en casa y sientes que no aportas.
            </p>
            <p data-id="element-48">Haces mil cosas… y aun así esa voz aparece, seca, puntual:</p>
            <p className="text-gold text-xl md:text-3xl not-italic font-bold" data-id="element-49">
              "Deberías hacerlo mejor."
            </p>
            <p data-id="element-50">
              Y lo peor no es la voz.
              <br data-id="element-51" />
              Lo peor es que, con el tiempo, empiezas a creer que esa voz es "la
              realidad".
            </p>
          </div>
        </div>

        {/* Product Mockup */}
        <div className="relative w-full max-w-sm mx-auto mb-8" data-id="element-52">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-30" data-id="element-53"></div>
          <img src="https://cdn.magicpatterns.com/uploads/daRwLhkLWduhSxzd84PeoT/mockup.png" alt="Silencia a la Mamá Juez en tablet" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-54" />
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center w-full max-w-sm" data-id="element-55">
          <button onClick={scrollToBuy} className="w-full bg-gold hover:bg-gold/90 text-navy font-bold py-4 px-8 rounded shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all hover:scale-[1.02] flex items-center justify-center gap-2 text-lg" data-id="element-56">
            Quiero Conocer la Guía
            <ArrowRight className="w-5 h-5" data-id="element-57" />
          </button>
        </div>
      </div>
    </section>;
}